import 'core-js'

import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'

import Icon from 'app/views/components/Icon'

// Core UIKIT  - Includes css and javascript
import 'uikit'

// Style Overrides
import 'static/less/theme.less'
import 'static/less/hackedu.less'
import 'static/less/hackedu-uikit.less'
import 'static/less/new_theme.less'
import 'remixicon/fonts/remixicon.css'

// Config
import store, { history } from 'app/state/store'

// Containers
import App from 'app/views/containers/App'


function Application() {
  let cookies = false
  let localStorage = false

  if (navigator.cookieEnabled) {
    cookies = true
  }
  document.cookie = 'cookietest=1'
  const enabled = document.cookie.indexOf('cookietest=') > -1
  document.cookie = 'cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT'
  cookies = enabled

  try {
    window.localStorage.setItem('hackedu.check.ls', 'true')
    window.localStorage.removeItem('hackedu.check.ls')
    localStorage = true
  } catch (e) {
    localStorage = false
  }
  if (!localStorage || !cookies) {
    return (
      <div
        className="uk-background-primary uk-width-1-1 uk-position-absolute uk-height-1-1 uk-flex uk-flex-middle uk-flex-center uk-flex-column"
        style={{
          opacity: 0.9,
          color: '#FFFFFF',
        }}
      >
        <Icon
          name="error-warning"
          ratio={3.5}
        />
        <br />
        <p className="uk-text-large uk-width-xlarge uk-text-center">
          Whoops! It looks like you have Cookies/Local Storage disabled,
          which is required to use HackEDU.
          Please turn this on for hackedu.com and refresh the page.
        </p>
      </div>
    )
  }

  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <App />
      </ConnectedRouter>
    </Provider>
  )
}

ReactDOM.render(<Application />,
  document.getElementById('app'))
